import { render, staticRenderFns } from "./agingStockAnalysis.vue?vue&type=template&id=ab6e8a1a&scoped=true"
import script from "./agingStockAnalysis.vue?vue&type=script&lang=js"
export * from "./agingStockAnalysis.vue?vue&type=script&lang=js"
import style0 from "./agingStockAnalysis.vue?vue&type=style&index=0&id=ab6e8a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6e8a1a",
  null
  
)

export default component.exports